import { z } from 'zod';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const BacsBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string().regex(/^[a-zA-Z0-9\\s]{4,34}$/, { message: 'Account Number should contain 4 to 34 letters or digits' }),
        sortCode: z.string().regex(/^\d{2}-?\d{2}-?\d{2}$/, { message: 'Sort code should contain 6 to 8 digits' }),
    }),
);

export class BacsBankAccountPayload extends BankAccountPayload {
    accountNumber: string;
    sortCode: string;
}
